export default {"src":"/_next/static/media/arrow_forward.400cd7ad.svg","height":15,"width":14};